import { WatchGroup } from "@acng/frontend-relativity";
import { AttributeLink, AttributeSetup, NodeUpgrade } from "@acng/frontend-stargazer";
import { Actor } from "acng/layout/context/list";
import { ctxAmateur } from "../context/amateur";
import { user } from "../../user/user.js";
import { cdn } from "acng/core/service/cdn";
import { STYLE_EMPTY, swapClass } from "acng/layout/service/style";
import { STYLE_INIT } from "acng/layout/style";
import { size } from "@acng/frontend-bounty/std/array.js";
import { get as getMovie } from "acng/moviePool/service/cache.js";
import { inject } from "acng/core/service/ng.js";


export const GALLERY_LIST = 'gallery-list';

AttributeSetup(GALLERY_LIST, (name) => {
  const watch = WatchGroup(`[${name}]`, ctxAmateur);
  const provideList = Actor();
  const limit = 64;

  AttributeLink(name, (element) => {
    watch(element, (element, [amateur]) => {
      let isEmpty = false;
      const fsk = `${user.getListFsk()}`;

      /**
       * @param {number} offset
       */
      const more = async (offset) => {
        if (!amateur || isEmpty || offset % limit) {
          console.debug('No more items to fetch or invalid offset.');
          return [];
        }


        const params = new URLSearchParams({
          offset: `${offset}`,
          limit: `${limit}`,
          fsk,
          nickname: amateur.nickname,
        });

        const response = /** @type {Response} */ (await cdn(`/api/amateur-profile/galleries?${params}`));
        isEmpty = swapClass(element, STYLE_EMPTY, !offset && !size(response.data));
        swapClass(element, STYLE_INIT, false);

        return response.data;

      };
      swapClass(element, STYLE_INIT, true);
      provideList(element, more, async (item) => {
        let gallery;
        if (item.type === 'movie') {
          gallery = await getMovie(item.id);
        } else if (item.type === 'picture') {
          const PictureSet = inject('PictureSet');

          gallery = (await PictureSet.get(item.id));
        } else {
          throw new Error(`Unknown gallery item type: ${item.type}`);
        }
        if (!gallery) {
          throw new Error(`Gallery item not found: ${item.type} with ID ${item.id}`);
        }
        return (element, engine) => {
          NodeUpgrade(engine, { gallery });
          return (element) => {
            //todo add click action for lightbox to play movie
          };
        }
      });
    });
  });

});

/** 
 * @typedef Response
 * @property {Array<ListItem>} data
 * @property {number} total
 */

/**
 * @typedef ListItem
 * @property {number} id
 * @property {('movie' | 'picture')} type
 */

/**
 * @typedef GalleryItem
 * @property {Movie | any} gallery
 * @property {('movie' | 'picture')} type
 */
